export const AuthMenu = [
  {
    label: 'Dashboard',
    pathname: '/',
  },
  {
    label: 'Notifications',
    pathname: '/notification',
  },
  {
    label: 'Annotations',
    pathname: '/annotations',
  },
  {
    label: 'Analysis',
    pathname: '/analysis',
  },
  {
    label: 'Live',
    pathname: '/live',
  },
  {
    label: 'Devices',
    pathname: '/devices',
  },
  {
    label: 'Settings',
    pathname: '/admin',
  },
  {
    label: 'Preferences',
    pathname: '/preferences',
  },
  {
    label: 'Chat',
    pathname: 'https://chat.safereaction.com',
    external: true,
  },
  {
    label: 'Logout',
    pathname: '/login',
  }
];

export const LoginMenu = [
  {
    label: 'Login',
    pathname: '/login',
  }
];
